import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ReasonService } from "./reasons.service";

export const allReasonsResolver: ResolveFn<void> = async () => {
  await inject(ReasonService).fetchAllReasonsLookup();
}

